import { defineMessages } from 'react-intl.macro';

export const messages = defineMessages({
  clear: {
    id: 'ClearableLabel.clear',
    defaultMessage: 'Clear',
    description: 'Clear selected filter button content',
  },
});
